import { render } from "./PreviewImage.vue?vue&type=template&id=4e5951da&scoped=true&ts=true"
import script from "./PreviewImage.vue?vue&type=script&lang=ts"
export * from "./PreviewImage.vue?vue&type=script&lang=ts"

import "./PreviewImage.vue?vue&type=style&index=0&id=4e5951da&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e5951da"]])

export default __exports__